import { lazy } from "react";

export const UpdateArticleAsync = lazy(() => import("./UpdateArticle"));
